export async function show({}) {
  const data = await this.$frontendRepositories.accounts.show();
  return data
}

export async function store({}, payload) {
  const data = await this.$frontendRepositories.accounts.store(payload);
  return data
}
